export default __webpack_public_path__ + "static/media/rlLab3Low.ab609f70.jpg";